<kendo-formfield>
    <kendo-label *ngIf="!!caption" text="{{ caption | translate}}"></kendo-label>
    <kendo-numerictextbox 
    [id]="formControlName"
    [ngClass]="{'fx-fill': settings.fxFill}"  
     [format]="settings.format" 
     [formControl]="control"
     [readonly]="settings.readonly"  
     [step]="settings.step"
     [min]="settings.min"
     [max]="settings.max"
     (valueChange)="onChange($event)"
     (blur)="onBlur()">
</kendo-numerictextbox>
</kendo-formfield>

